import { approverType, requestStatus } from "../../../constants";
import { requestStatusTypes } from "../info-technology-process/types";

export const transformRequestStatus = (
  status: string,
  options?: Partial<{ isDemand: boolean; step: number }>
) => {
  const step = options?.step;

  if (status === requestStatus.submitted && step === approverType.assignee) {
    return requestStatusTypes.submittedAssignee;
  }
  if (status === requestStatus.preApproved) {
    return requestStatus.submitted;
  }
  if (status === "InProgress") {
    return requestStatus.inProgress;
  }

  return status;
};
